import { Box, Tag } from '@televet/kibble-ui';
import React from 'react';
import { FormQuestionType } from 'shared/types/forms';
import { Maybe } from 'shared/types/graphql';
import { formatPhoneNumber } from 'shared/utils';
import { FormAnswer } from './FormAnswer';
import { FormAnswersContainer } from './FormAnswersContainer';
import { FormAnswerWithContent } from './FormAnswerWithContent';
import { RequestFormInput } from './types';

type AnswersProps = {
  primaryPhoneNumber: Maybe<string>;
  formQuestionAnswers: RequestFormInput[];
  small?: boolean;
  borderLeftColor?: string;
  showNewClientTag?: boolean;
  clinicWidgetRequestId?: string;
};

export const Answers = ({
  primaryPhoneNumber,
  formQuestionAnswers,
  small,
  borderLeftColor,
  showNewClientTag,
  clinicWidgetRequestId,
}: AnswersProps): JSX.Element => {
  return (
    <FormAnswersContainer
      borderLeftColor={borderLeftColor}
      small={small}
      data-testid={`widget-request-answers-${clinicWidgetRequestId}`}
    >
      {showNewClientTag && (
        <Box>
          <Tag variant="success" label="New Client" size="sm" />
        </Box>
      )}
      {Boolean(primaryPhoneNumber) && (
        <FormAnswer small={small} question="Phone Number">
          {formatPhoneNumber(primaryPhoneNumber)}
        </FormAnswer>
      )}
      {formQuestionAnswers
        ?.filter(
          (question) => question.type !== FormQuestionType.ratingInput && question.type !== FormQuestionType.textBlock,
        )
        .map((question, index) => (
          <FormAnswerWithContent small={small} key={index} question={question} />
        ))}
    </FormAnswersContainer>
  );
};
